import moment from 'moment';
import range from './range.js';

export const currentYear = moment().format('YYYY');

function yearListOptions() {
	return range(Number.parseInt(currentYear), Number.parseInt(currentYear) + 10);
}

export default yearListOptions;
